import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import FieldInput from 'common/components/FieldInput';
import styles from './styles.module.scss';

const FormForgotPasswordResetView = ({values}) => {

  return (
    <div className={styles.forgotPasswordReset}>
      <h2>איפוס ססמה</h2>
      <p className={styles.description}>קוד אימות נשלח אל כתובת האימייל המשוייכת
        לחשבון אנא הזן את קוד האימות לאיפוס הססמה</p>
      <Form>
        <div className={styles.verificationCode}>
          <FieldInput
            fieldId="verificationCode"
            value={values.verificationCode}
            label="קוד אימות"
            classNames={{
              input: styles.input,
              label: styles.label,
            }}
          />
        </div>
        <button
          type="submit"
          className={styles.buttonSend}>
          <span>אישור</span>
        </button>
      </Form>
    </div>
  );
};

FormForgotPasswordResetView.propTypes = {
  values: PropTypes.object
};

export default FormForgotPasswordResetView;
